function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.987 28.5a18.5 18.5 0 11-37 0 18.5 18.5 0 1137 0z",
  strokeWidth: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.6 7a4.5 4.5 0 00-.828 6.31c.105.136.238.237.354.358l-.05.038 1.219 1.587 7.138-5.482-1.218-1.586-.05.038c-.086-.144-.15-.298-.255-.435A4.5 4.5 0 0011.6 7zM45.373 7a4.5 4.5 0 01.829 6.31c-.105.136-.238.237-.354.358l.05.038-1.219 1.587-7.138-5.482 1.218-1.586.05.038c.086-.144.15-.298.255-.435A4.5 4.5 0 0145.374 7z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.487 6v2h2.667v2h2.666V8h2.667V6h-8z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.487 11.2v5M28.487 40.8v5M16.387 28.5h-5M45.387 28.5h-5M19.824 13.468l2.5 4.33M34.624 39.102l2.5 4.33M17.995 34.5l-4.33 2.5M43.11 20l-4.33 2.5"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.48 19.757l4.33 2.5M39.114 34.557l4.33 2.5M22.412 38.886l-2.5 4.33M36.912 13.77l-2.5 4.331"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.587 16.153l3.318 12.362-8.692 2.333"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.497 47.575c.908.648 2.393.157 3.318-1.1.064-.087.108-.18.163-.269l.024.016.744-1.011-3.285-2.354-.745 1.011.024.016c-.07.08-.145.15-.21.237-.924 1.257-.938 2.802-.03 3.451zM41.477 47.575c-.908.648-2.393.157-3.318-1.1-.064-.087-.108-.18-.163-.269l-.024.016-.744-1.011 3.285-2.354.745 1.011-.024.016c.07.08.145.15.21.237.924 1.257.938 2.802.03 3.451z"
})));

var SvgAlarmclock = function SvgAlarmclock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlarmclock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Alarm clock.52a385c6.svg";
export { ForwardRef as ReactComponent };